import { Button } from '~/components/common/Button'

import React from 'react'
import BaseModal from './base/BaseModal'

interface SettingSecurityRequestModalProps {
  isOpen: boolean
  onOpenChange: () => void
  onConfirm: () => void
  onCancel?: () => void
}

const SettingSecurityRequestModal: React.FC<SettingSecurityRequestModalProps> = ({
  isOpen,
  onOpenChange,
  onConfirm,
  onCancel
}) => {
  const handleNo = () => {
    onCancel?.()
    onOpenChange()
  }

  const handleYes = () => {
    onConfirm()
    onOpenChange()
  }

  return (
    <BaseModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title='Upload Security Settings XML'
      contentClassName='w-[550px] h-[250px]'
      className='w-[400px] z-[999999]'
      bodyClassName='pt-0'
    >
      <div>
        <div className='flex flex-col justify-center items-start gap-2 mt-4 text-base'>
          <p>
            You have just uploaded `settings.xml`. If it contains encrypted passwords, upload
            `settings-security.xml` as well.
          </p>
          <ul>
            <li>
              Upload `settings-security.xml` when your Maven settings use encrypted credentials.
            </li>
            <li>If it does not, you can skip this step.</li>
          </ul>
        </div>
        <div className='mt-4 w-full flex justify-end gap-4'>
          <Button variant='outlined' className='mt-2' onClick={handleNo}>
            Skip For Now
          </Button>
          <Button variant='primary' className='mt-2' onClick={handleYes}>
            Upload Security Settings
          </Button>
        </div>
      </div>
    </BaseModal>
  )
}

export default SettingSecurityRequestModal
